import { Menu as MenuPrimitive } from '@base-ui/react/menu';

import { cn } from '@/lib/utils';

export type DropdownMenuItemProps = MenuPrimitive.Item.Props & {
  inset?: boolean;
  variant?: 'default' | 'destructive';
};

const DropdownMenuItem = ({
  className,
  inset,
  variant = 'default',
  ...props
}: DropdownMenuItemProps) => {
  return (
    <MenuPrimitive.Item
      data-slot="dropdown-menu-item"
      data-inset={inset}
      data-variant={variant}
      className={cn(
        'group/dropdown-menu-item relative flex items-center gap-1.5 outline-hidden',
        'rounded-md px-1.5 py-1 text-sm',
        'cursor-pointer select-none data-inset:pl-7',
        "[&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",

        'focus:bg-primary focus:text-gray-900',

        'data-[variant=destructive]:text-red-400 data-[variant=destructive]:*:[svg]:text-red-400',
        'data-[variant=destructive]:focus:bg-red-400/90 data-[variant=destructive]:focus:text-white data-[variant=destructive]:focus:*:[svg]:text-white',
        'not-data-[variant=destructive]:not-data-disabled:focus:**:text-gray-900',

        'data-disabled:cursor-not-allowed data-disabled:bg-white! data-disabled:text-gray-500! data-disabled:*:[svg]:text-gray-500!',
        className,
      )}
      {...props}
    />
  );
};

export default DropdownMenuItem;
